// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__vbP23","meals-appear":"AvailableMeals_meals-appear__uilf5"};